import { Button, Form, TextInput } from "armstrong-react";
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router";
import _ from "underscore";

import { Logo } from "../../../core/atoms";
import { isBrowser } from "../../../core/detection";
import { getQueryStringValue } from "@travellocal/utils/urlHelpers";

import "./requestPasswordResetForm.scss";

interface Props {
  submit: (data: IForgottenPasswordRequest) => Promise<any>;
  routeToLogin: string;
}

interface State {
  email?: string;
  errorMessage?: string;
  submitted?: boolean;
}

export default class ForgottenPasswordForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      email: "",
      submitted: false
    };
  }

  private submit = async () => {
    let trimmed = this.state.email.trim();
    if (trimmed.length < 1) {
      return;
    }

    try {
      await this.props.submit({ username: trimmed });
      this.setState({ errorMessage: null, submitted: true });
    }
    catch (e) {
      let err = e as IApiErrorResponse;
      this.setState({ errorMessage: err.message });
    }
  }

  componentWillMount() {
    if (isBrowser()) {
      // Handle links from login forms
      let email = getQueryStringValue("email");
      if (email != null && email.length > 0) {
        this.setState({ email: email });
      }
    }
  }

  render() {
    return (
      <div className="forgotten-password">
        <Helmet title="Reset your TravelLocal password" />

        <div className="wrap">
          <Logo type="accent" link={this.props.routeToLogin} width={96} />
          <p className="subtitle">Step {this.state.submitted ? 2 : 1}/3</p>
          <h1>Reset your password</h1>
          <p>If you've forgotten the password to your TravelLocal account, it's easy to get a new one.</p>

          <hr/>

          {this.state.errorMessage &&
            <div className="validation-bar">Something went wrong - did you type your email address correctly? ({this.state.errorMessage})</div>
          }

          {!this.state.submitted &&
            <Form dataBinder={Form.jsonDataBinder(this.state)} onDataChanged={() => this.forceUpdate()}>
              <p>In the box below, type the email address that you used when you created your account. We will send an email to that address, which will contain a link back to our system - click on that and follow the instructions.</p>

              <label>What's your email address?</label>
              <TextInput {...Form.Bind.textEmail("email") } placeholder="e.g. traveller@example.com" />

              <Button type="submit" disabled={this.state.email.trim().length < 1} onClick={() => this.submit()} leftIcon={Button.Icomoon.reset}>Send me a reset email</Button>
            </Form>
          }
          {this.state.submitted &&
            <div className="submitted">
              <p>Ok! We've sent an email to <strong>{this.state.email}</strong>. Please check your email inbox in a few minutes' time, and click on the link in the email we sent.</p>
              <p>If you haven't received the email, please check your junk mail folder.</p>
              <p>Otherwise, <a onClick={() => this.setState({ submitted: false })}> click here to try again.</a></p>
            </div>
          }

          <hr/>

          <p>If you're having difficulties, call us on +44 (0)117 325 7898 or email us at <a href="mailto:team@travellocal.com">team@travellocal.com</a></p>

          <p className="m-top-medium">Changed your mind? Remembered your password? <Link to={this.props.routeToLogin}>Click here to go back to the login page.</Link></p>
        </div>
        <div className="image-bg" />
      </div>
    );
  }
}
